/**
 * Generated by orval v8.19.0 🍺
 * Do not edit manually.
 * Payin admin
 * Payin application
 * OpenAPI spec version: 1.0
 */

export enum PayinCommonTraderV1Status {
    STATUS_UNSPECIFIED = 'STATUS_UNSPECIFIED',
    STATUS_CREATED = 'STATUS_CREATED',
    STATUS_ACTIVE = 'STATUS_ACTIVE',
    STATUS_BLOCKED = 'STATUS_BLOCKED',
}
